import { ErrorMessage } from "@hookform/error-message";
import { FC } from "react";
import { FieldErrorsImpl } from "react-hook-form";
import styled from "styled-components";

import { FormErrorModel } from "@ryde/shared";
import { redMui } from "@ryde/theme";

export const ErrorBoxStyled = styled.p`
  color: ${redMui._600};
`;

interface IErrorsDisplayProps {
  fieldName: string;
  errors: Partial<FieldErrorsImpl<Record<string, FormErrorModel>>>;
}

export const ControlErrorDisplay: FC<IErrorsDisplayProps> = ({
  fieldName,
  errors,
}) => {
  return (
    <ErrorMessage
      errors={errors}
      name={fieldName}
      render={({ message }) => {
        return !!message && <ErrorBoxStyled>{message}</ErrorBoxStyled>;
      }}
    />
  );
};
